<script setup lang="ts">
import 'swiper/css'
import 'swiper/css/autoplay'

import { Swiper, SwiperSlide } from 'swiper/vue'
import { Autoplay } from 'swiper'
import type { StoryblokAsset } from '../../types'

interface Props {
  blok: {
    sponsors: StoryblokAsset[]
  }
}

defineProps<Props>()

const containerRef = ref()
const { width } = useElementSize(containerRef)
const slidesPerView = computed(() => {
  return Math.round(width.value / (170 + 48))
})
</script>

<template>
  <ClientOnly>
    <div ref="containerRef" class="flex flex-col items-center gap-3 pb-5 pt-10 px-[4px] md:px-0 select-none">
      <div class="flex lg:hidden gap-0 flex-wrap w-full justify-center items-center max-w-[780px]">
        <div v-for="sponsor in blok.sponsors" :key="sponsor.id" class="flex justify-center items-center w-[33.3%] max-w-[135px] h-[48px]">
          <img :src="sponsor.filename">
        </div>
      </div>
      <div v-if="slidesPerView" class="hidden lg:block w-full">
        <Swiper
          :modules="[Autoplay]"
          :slides-per-view="slidesPerView"
          :space-between="48"
          loop
          :autoplay="{ delay: 1000, disableOnInteraction: false, pauseOnMouseEnter: false }"
          :speed="11000"
          :loop-additional-slides="100"
          class="my-swiper"
        >
          <SwiperSlide v-for="sponsor in blok.sponsors" :key="`slider-${sponsor.id}`">
            <div class="flex justify-center items-center w-[170px] h-[48px]">
              <img :src="sponsor.filename">
            </div>
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  </ClientOnly>
</template>

<style scoped>
.my-swiper {
  width: 100%;
}
</style>
